/**
 * @author Marco
 * @date 2025-12-28
 */

import {INodeProperties} from 'n8n-workflow';

export const automationOperations: INodeProperties[] = [
	{
		displayName: 'Operation',
		name: 'operation',
		type: 'options',
		noDataExpression: true,
		displayOptions: {
			show: {
				resource: ['automation'],
			},
		},
		options: [
			{
				name: 'Get Config',
				value: 'getConfig',
				description: 'Get automation configuration including AI model settings',
				action: 'Get automation config',
			},
			{
				name: 'Report Job Created',
				value: 'reportJobCreated',
				description: 'Report to InNotes that a job was created by the automation workflow',
				action: 'Report job created',
			},
		],
		default: 'getConfig',
	},
];

export const automationFields: INodeProperties[] = [
	// reportJobCreated fields
	{
		displayName: 'Jobs Added',
		name: 'jobsAdded',
		type: 'number',
		required: true,
		displayOptions: {
			show: {
				resource: ['automation'],
				operation: ['reportJobCreated'],
			},
		},
		default: 1,
		description: 'Number of jobs added by this workflow execution',
	},
	{
		displayName: 'Status',
		name: 'status',
		type: 'options',
		displayOptions: {
			show: {
				resource: ['automation'],
				operation: ['reportJobCreated'],
			},
		},
		options: [
			{
				name: 'Success',
				value: 'success',
			},
			{
				name: 'Error',
				value: 'error',
			},
		],
		default: 'success',
		description: 'Status of the workflow execution',
	},
	{
		displayName: 'Error Message',
		name: 'errorMessage',
		type: 'string',
		displayOptions: {
			show: {
				resource: ['automation'],
				operation: ['reportJobCreated'],
				status: ['error'],
			},
		},
		default: '',
		description: 'Error message if the workflow failed',
	},
];
